<template>
  <div ref="messages" class="intelligence-messages px-4 py-4" aria-live="polite">
    <div v-if="!messages.length" class="intelligence-messages__empty">
      <div class="intelligence-messages__welcome">
        <span class="intelligence-messages__welcome-logo">
          <img src="/favicon-32x32.png" alt="" aria-hidden="true" />
        </span>
        <p class="f16 fw500 line-height-3">{{ introduction }}</p>
      </div>
      <ProAppIntelligenceStarterSuggestions
        :suggestions="suggestions"
        :disabled="thinking"
        @select="$emit('send', $event)"
      />
    </div>
    <template v-else>
      <ProAppIntelligenceMessage
        v-for="message in messages"
        :key="message.id"
        :message="message"
      />
      <ProAppIntelligenceThinkingMessage v-if="thinking" />
    </template>
  </div>
</template>

<script>
import ProAppIntelligenceMessage from './ProAppIntelligenceMessage'
import ProAppIntelligenceStarterSuggestions from './ProAppIntelligenceStarterSuggestions'
import ProAppIntelligenceThinkingMessage from './ProAppIntelligenceThinkingMessage'

export default {
  name: 'ProAppIntelligenceMessageList',
  components: {
    ProAppIntelligenceMessage,
    ProAppIntelligenceStarterSuggestions,
    ProAppIntelligenceThinkingMessage,
  },
  props: {
    messages: {
      type: Array,
      default: () => [],
    },
    suggestions: {
      type: Array,
      default: () => [],
    },
    introduction: String,
    thinking: Boolean,
  },
  watch: {
    messages: {
      deep: true,
      handler() {
        this.scrollToLatest()
      },
    },
    thinking() {
      this.scrollToLatest()
    },
  },
  mounted() {
    this.scrollToLatest()
  },
  methods: {
    scrollToLatest() {
      this.$nextTick(() => {
        const messages = this.$refs.messages
        if (messages) messages.scrollTop = messages.scrollHeight
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.intelligence-messages {
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 14px;
  overflow-y: auto;
  overscroll-behavior: contain;
  background: white;
  scrollbar-width: thin;
  scrollbar-color: var(--v-primary-lighten3) var(--v-secondary-lighten4);

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: var(--v-secondary-lighten4);
  }

  &::-webkit-scrollbar-thumb {
    background: var(--v-primary-lighten3);
    border-radius: 8px;
  }

  &__empty {
    min-height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 24px;
  }

  &__welcome {
    display: flex;
    align-items: center;
    gap: 12px;
    color: var(--v-secondary-darken4);

    p {
      min-height: 42px;
      display: flex;
      align-items: center;
      margin: 0;
      line-height: 18px !important;
    }
  }

  &__welcome-logo {
    width: 42px;
    height: 42px;
    flex: 0 0 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: var(--v-secondary-lighten5);
    box-shadow: 0 3px 4px rgba(133, 133, 133, 0.18);

    img {
      display: block;
      width: 30px;
      height: 30px;
    }
  }
}

@media screen and (max-width: 460px) {
  .intelligence-messages__empty {
    justify-content: flex-start;
    padding-top: 8px;
  }
}
</style>
